import $ from 'jquery';
import EventEmitter from '../event-emitter';
import inherit from '../inherit';
import { NAVIGATE, ITEM_CLICK } from "./events";

function PlayList(configs) {
  EventEmitter.call(this);
  this.configs = configs;

  this.templateData = null;
  this.$html = null;
  this.$playlist = null;
  this.$items = null;

  this.itemsInPage = this.configs.itemsInPage;
  this.currentPage = this.configs.initialPage;
}

$.extend(PlayList, {
  extendNavigateEvent(e, props) {
    return $.extend(e, {
      detail: props
    });
  }
});

inherit(PlayList, EventEmitter, {
  /**
   *
   * @param {PlayListTemplateData} templateData
   * @returns {jQuery}
   */
  render(templateData) {
    this.templateData = templateData;
    this.$html = $(this.configs.render(templateData));
    this.$playlist = this.$html.find(this.configs.selectors.playList);
    this.$items = this.$html.find(this.configs.selectors.items);
    this.bindEvents();
    return this.$html;
  },
  destroy() {
    if (this.$html) {
      this.$html.remove();
      this.$html = null;
      this.$playlist = null;
      this.$items = null;
      this.templateData = null;
      this.currentPage = 1;
    }
  },
  /**
   * 페이지를 입력하면 해당 페이지의 리스트를 출력한다.
   * 한번에 최대 this.itemsInPage 만큼만 그리는데, css가 first-child만 마진을 없애주고 있어서 그렇다.
   * 리팩토링 전에는 전체 리스트를 다시 소팅 하는 방식이었다.
   * @param {number} p - 1-indexed integer
   */
  goToPage(p) {
    const $items = this.$items;
    const maxPage = Math.ceil($items.length / this.itemsInPage);
    const index = Math.min(Math.max(p, 1), maxPage) - 1;
    const startIndex = index * this.itemsInPage;
    const $itemsToShow = $items.slice(startIndex, startIndex + this.itemsInPage);
    this.$html.find(this.configs.selectors.playList).html($itemsToShow);
    this.currentPage = index + 1;
  },
  next() {
    this.goToPage(this.currentPage + 1);
  },
  prev() {
    this.goToPage(this.currentPage - 1);
  },
  hasNext() {
    const $items = this.$items;
    return this.currentPage !== Math.ceil($items.length / this.itemsInPage);
  },
  hasPrev() {
    return this.currentPage > 1;
  },
  bindEvents() {
    this.bindNavigationButtonClickEvents();
    this.bindItemClickEvents();
  },
  /**
   * 플레이리스트 페이징을 할때마다 현재 페이지를 체크한다. 이전, 다음 페이지가 없으면 비활성화 표시
   */
  toggleNavButtonView() {
    const offClassName = this.configs.classNames.off;
    const $btnPrev = this.$html.find(this.configs.selectors.btnPrev);
    const $btnNext = this.$html.find(this.configs.selectors.btnNext);
    this.hasPrev() ? $btnPrev.removeClass(offClassName) : $btnPrev.addClass(offClassName);
    this.hasNext() ? $btnNext.removeClass(offClassName) : $btnNext.addClass(offClassName);
  },

  /**
   *
   * @emits navigate
   */
  bindNavigationButtonClickEvents() {
    const activeBtnPrevSelector = `${this.configs.selectors.btnPrev}:not(.${this.configs.classNames.off})`;
    const activeBtnNextSelector = `${this.configs.selectors.btnNext}:not(.${this.configs.classNames.off})`;
    this.$html.on('click', activeBtnPrevSelector, (e) => {
      this.prev();
      this.toggleNavButtonView();
      this.emit(NAVIGATE, PlayList.extendNavigateEvent(e, { delta: -1, page: this.currentPage }));
    });
    this.$html.on('click', activeBtnNextSelector, (e) => {
      this.next();
      this.toggleNavButtonView();
      this.emit(NAVIGATE, PlayList.extendNavigateEvent(e, { delta: 1, page: this.currentPage }));
    });
  },

  bindItemClickEvents() {
    this.$html.on('click', this.configs.selectors.items, (e) => {
      this.emit(ITEM_CLICK, e);
    });
  }
});


export default PlayList;


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/video-playlist/playlist.js
 **/